<template>
    <div class="network-banner">
        <!-- <hp5-semantic size-selection="xs">
            <BaseIconAccessibilityDecorator :screenReaderText="screenReaderText">
                <hp5-icon :name="iconName" size="xs" />
            </BaseIconAccessibilityDecorator>
            <b class="header">{{header}}</b>
            <slot></slot>
            
        </hp5-semantic> -->
        <!--replacing the custom component with inline alert component which comes with a colored icon by default. keep the old the code just in case we have to revert if the test fails for accessibility-->
        <hp5-alert :type="bannerType" hide-alert-text inline :show-alert="true">
            <hp5-semantic size-selection="xs">
                <span><b v-if="header" class="header">{{header}}</b>
                    <slot></slot>
                </span>
            </hp5-semantic>
        </hp5-alert>
    </div>
</template>
<script setup>

    const props = defineProps({
        bannerType: {
            type: String,
            required: true,
            validate(value) {
                return ['success', 'warning', 'info', 'error'].includes(value)
            }
        },
        header: {
            type: String,
            required: false
        }
    })

    const bannerType = computed(() => {
        return props.bannerType
    })
    const iconName = computed(() => {
        if (props.bannerType == 'success') return 'system-success-base'
        if (props.bannerType == 'warning') return 'system-warning'
        if (props.bannerType == 'info') return 'system-info' 
        if (props.bannerType == 'error') return 'system-error-base'
    })

    const screenReaderText = computed(() => {
        if (props.bannerType == 'success') return 'Success!'
        if (props.bannerType == 'warning') return 'Warning!'
        if (props.bannerType == 'info') return 'Information!' 
        if (props.bannerType == 'error') return 'Important!'
    })

    const backgroundColor = computed(() => {
        if (props.bannerType == 'success') return '#e7f6e6'
        if (props.bannerType == 'warning') return '#f8e5dd'
        if (props.bannerType == 'info') return 'var(--color-neutral-xlight)' 
        if (props.bannerType == 'error') return '#ffeaef'
    })

</script>

<style scoped lang="scss">
@use '../../../assets/scss/breakpoints' as *;

    .network-banner {
        background-color: v-bind(backgroundColor);
        padding: 8px;
        padding-top:0px;
        padding-bottom: 0px;
        hp5-icon {
            vertical-align: middle;
        }

        .header {
            margin-right: var(--spacing-xxs);
            @include small-up {
                width: auto;
            }
        }
       
    }
</style>